
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IScreen, IScreenTagDialogueData } from '../../models';
import { GlobalSettings } from '../../common';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tags-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule
],
    templateUrl: './tags-dialog.component.html',
    styleUrl: './tags-dialog.component.scss'
})
export class TagsDialogComponent implements OnInit, AfterViewInit  {

  editTagForm!: FormGroup;

  screen: IScreen;
  limits = GlobalSettings.characterLimits;

  @ViewChild('tagInput') tagInput!: ElementRef<HTMLInputElement>;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TagsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IScreenTagDialogueData
  ) {
    this.screen = data.screen;
  }

  ngOnInit(): void {
    this.initializeTagForms();
  }

  ngAfterViewInit(): void {
    this.tagInput.nativeElement.focus();
  }


  initializeTagForms() {
    this.editTagForm = this.fb.group({
      tag_name: ['', [Validators.required]]
    });
  }

  onAddTag() {
    if (this.data.canEdit === false) return;
    if (this.editTagForm.valid) {
      if (this.data.onTagUpdate) {
        this.data.onTagUpdate('add', this.editTagForm.value.tag_name);
      } else {
        this.dialogRef.close({
          action: 'add',
          tag: this.editTagForm.value.tag_name
        });
      }
      this.editTagForm.reset();
    }
  }

  onRemoveTag(tag: string) {
    if (this.data.canEdit === false) return;
    if (this.data.onTagUpdate) {
      this.data.onTagUpdate('remove', tag);
    } else {
      this.dialogRef.close({
        action: 'remove',
        tag: tag
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
